import { render, staticRenderFns } from "./NewApprovalChainTemplateDialog.vue?vue&type=template&id=51ddab98&"
import script from "./NewApprovalChainTemplateDialog.vue?vue&type=script&lang=js&"
export * from "./NewApprovalChainTemplateDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports